<template>
	<v-menu offset-y>
		<template #activator="{ on }">
			<v-btn icon v-on="on">
				<v-icon class="font-size-grande material-icons">mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list class="pa-1">
			<v-list-item-group>
				<div v-if="deveExibirAcaoConcluirEdicao && !modoVisualizacao">
					<v-list-item
						v-az-auth="permissoes.ataEditorTextoSincronizar"
						data-testid="action-convite"
						@click="$emit('concluir-edicao-documento')"
					>
						<v-list-item-icon>
							<tooltip-informacao
								mensagem="Existe um termo de desentranhamento em elaboração para este documento.
										Clique na ação para acessar as etapas da elaboração."
								:tamanho-icone="tamanhoIconeMenu"
								v-if="possuiTermoDesentranhamento()"
								class="mr-2"
								color="primary"
							></tooltip-informacao>
							<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-account-plus</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="texto-menu-interno">Concluir Edição</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</div>
				<v-list-item
					data-testid="action-convite"
					@click="tratarEventoConvidarSignatarios"
					v-if="exibirAcaoConvidarSignatarios() && !modoVisualizacao"
				>
					<v-list-item-icon>
						<tooltip-informacao
							mensagem="Existe um termo de desentranhamento em elaboração para este documento.
										Clique na ação para acessar as etapas da elaboração."
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-account-plus</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Convite</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item
					data-test-id="action-enviar-fornecedor"
					@click="tratarEventoEnviarFornecedor"
					v-if="podeEnviarFornecedor && !modoVisualizacao"
				>
					<v-list-item-icon>
						<v-icon :size="tamanhoIconeMenu" class="material-icons">mdi-send</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Enviar Fornecedor</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-divider v-if="exibirAcaoConvidarSignatarios"></v-divider>

				<v-list-item
					v-if="exibirAcaoDesentranhar() && !modoVisualizacao"
					v-az-auth="permissoes.processoDigitalTermoDesentranhamentoCriar"
					@click="verificarRedigirTermoDesentranhamento"
				>
					<v-list-item-icon>
						<tooltip-informacao
							:mensagem="getMensagemTooltip()"
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon v-else class="material-icons" :size="tamanhoIconeMenu">mdi-close</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Desentranhar</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					class="list-item-height"
					v-if="exibirAcaoCancelar() && !modoVisualizacao"
					v-az-auth="permissoes.ataDocumentoProcessoDigitalCancelar"
					data-testid="action-cancelar"
					@click="$emit('cancelar')"
				>
					<v-list-item-icon>
						<tooltip-informacao
							:mensagem="getMensagemTooltip()"
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon v-else :size="tamanhoIconeMenu" class="material-icons mr-2"
							>mdi-close-circle-outline
						</v-icon>
					</v-list-item-icon>
					<v-list-item-title class="texto-menu-interno">Cancelar</v-list-item-title>
				</v-list-item>

				<v-list-item
					data-testid="action-sincronizar-area-publica"
					@click="$emit('sincronizar-area-publica')"
					v-az-auth="permissoes.ataDocumentoSincronizarAreaPublica"
					v-if="exibirAcaoSincronizarAreaPublica()"
				>
					<v-list-item-icon>
						<v-icon :size="tamanhoIconeMenu" class="material-icons">
							{{ iconeSincronizarAreaPublica() }}
						</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">
							{{ textoSincronizarAreaPublica() }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					data-testid="action-baixar"
					@click="$emit('baixar')"
					v-az-auth="permissoes.ataDocumentoBaixar"
				>
					<v-list-item-icon>
						<tooltip-informacao
							mensagem="Existe um termo de desentranhamento em elaboração para este documento.
										Clique na ação para acessar as etapas da elaboração."
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-download</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Baixar</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<div v-if="temPermissaoEdicao && !documentoOuAnexoEstaJuntado(documentoOuAnexo) && !modoVisualizacao">
					<v-list-item
						class="list-item-height"
						data-testid="action-excluir"
						@click="$emit('excluir')"
						v-az-auth="permissoes.ataDocumentoExcluir"
					>
						<v-list-item-icon>
							<tooltip-informacao
								:mensagem="getMensagemTooltip()"
								:tamanho-icone="tamanhoIconeMenu"
								v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
								class="mr-2"
								color="primary"
							></tooltip-informacao>
							<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-delete</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="texto-menu-interno">Excluir</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</div>
				<div v-if="temPermissaoEdicao && isAtaPncp && !isDocumentoEnviadoPncp() && !modoVisualizacao">
					<v-list-item
						class="list-item-height"
						data-testid="action-enviar-pncp"
						@click="$emit('enviar-pncp')"
					>
						<v-list-item-icon>
							<tooltip-informacao
								mensagem="Envia o documento para o PNCP."
								:tamanho-icone="tamanhoIconeMenu"
								class="mr-2"
								color="primary"
							></tooltip-informacao>
							<v-icon :size="tamanhoIconeMenu" class="material-icons">mdi-send</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="texto-menu-interno">Enviar PNCP</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</div>
				<div v-if="temPermissaoEdicao && isDocumentoEnviadoPncp() && !modoVisualizacao">
					<v-list-item
						class="list-item-height"
						data-testid="action-excluir-pncp"
						@click="$emit('excluir-pncp')"
					>
						<v-list-item-icon>
							<v-icon :size="tamanhoIconeMenu" class="material-icons">mdi-delete</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="texto-menu-interno">Excluir PNCP</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</div>
			</v-list-item-group>
		</v-list>
	</v-menu>
</template>
<script>
import documentoMixin from '@/views/mixins/documento'
import { opcaoSimNao, situacoes, situacoesEdocs } from '@/core/constants'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import IconeTooltip from '@/views/components/IconeTooltip.vue'
import signatario from '@/views/mixins/signatarios/signatario'
import validacaoAta from '@/views/mixins/validacaoAta'
import TooltipInformacao from '@/views/components/TooltipInformacao.vue'

export default {
	name: 'acessar-ata-itens-btn-acoes',
	components: { TooltipInformacao, IconeTooltip, TextoTooltip },
	mixins: [documentoMixin, signatario, validacaoAta],
	props: {
		documentoOuAnexo: {
			type: Object,
			default: () => null,
		},
		isAtaPncp: {
			type: Boolean,
			default: false,
		},
		modoVisualizacao: {
			type: Boolean,
			default: false,
		},
		exibirSincronizarAreaPublica: {
			type: Boolean,
			default: false,
		},
	},
	emits: [
		'tratar-evento-desentranhar',
		'concluir-edicao-documento',
		'baixar',
		'excluir',
		'convidar-signatarios',
		'enviar-pncp',
		'excluir-pncp',
		'enviar-fornecedor',
		'sincronizar-area-publica',
	],
	data() {
		return {
			tamanhoIconeMenu: '18px',
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
		}
	},
	computed: {
		deveExibirAcaoConcluirEdicao() {
			return this.isDocumento(this.documentoOuAnexo) && this.documentoEstaCriado(this.documentoOuAnexo)
		},
		podeEnviarFornecedor() {
			return this.documentoOuAnexo.podeEnviarFornecedor
		},
	},
	methods: {
		tratarEventoConvidarSignatarios() {
			this.$emit('convidar-signatarios')
		},
		tratarEventoEnviarFornecedor() {
			this.$emit('enviar-fornecedor')
		},
		exibirAcaoConvidarSignatarios() {
			return !this.ehTermoDeDesentranhamento() && this.ehDocumentoEmRascunho() && this.isProcessoDigitalAtivo
		},
		exibirAcaoDesentranhar() {
			return !this.ehTermoDeDesentranhamento() && this.ehDocumentoJuntado()
		},
		exibirAcaoSincronizarAreaPublica() {
			const isDocEditor = this.documentoOuAnexo.extensao == null

			return (
				this.exibirSincronizarAreaPublica &&
				this.ehDocumentoConcluido() &&
				(this.isAnexoPdf(this.documentoOuAnexo) || isDocEditor)
			)
		},
		ehDocumentoJuntado() {
			return this.documentoOuAnexo.situacao === situacoes.DOCUMENTO.JUNTADO.value
		},
		ehDocumentoEmRascunho() {
			return this.documentoOuAnexo.situacao === situacoes.DOCUMENTO.RASCUNHO.value
		},
		verificarRedigirTermoDesentranhamento() {
			this.$emit('tratar-evento-desentranhar')
		},
		possuiTermoDesentranhamento() {
			return opcaoSimNao.SIM.value === this.documentoOuAnexo.possuiTermoDesentranhamento
		},
		ehTermoDeDesentranhamento() {
			return opcaoSimNao.SIM.value === this.documentoOuAnexo.ehTermoDesentranhamento
		},
		ehDocumentoConcluido() {
			return this.documentoOuAnexo.situacao !== situacoes.DOCUMENTO.CRIADO.value
		},
		exibirAcaoCancelar() {
			return !this.ehTermoDeDesentranhamento() && this.ehDocumentoJuntado()
		},
		isDocumentoEnviadoPncp() {
			return this.documentoOuAnexo.situacaoPncp === situacoes.DOCUMENTO_PNCP.ENVIADO.value
		},
		iconeSincronizarAreaPublica() {
			return this.documentoOuAnexo.isDocPublico ? 'mdi-close' : 'mdi-send'
		},
		textoSincronizarAreaPublica() {
			return `${this.documentoOuAnexo.isDocPublico ? 'Cancelar Envio' : 'Enviar'} Área Pública`
		},
		isDocumentoEnviadoEdocs() {
			return (
				situacoesEdocs.AGUARDANDO.value === this.documentoOuAnexo.situacaoEdocs ||
				situacoesEdocs.SINCRONIZADO.value === this.documentoOuAnexo.situacaoEdocs
			)
		},
		getMensagemTooltip() {
			if (this.isDocumentoEnviadoEdocs()) {
				return 'Não é possível realizar essa ação, pois o documento já foi ou está sendo enviado ao e-Docs.'
			}

			return 'Existe um termo de desentranhamento em elaboração para este documento. Clique na ação para acessar as etapas da elaboração.'
		},
	},
}
</script>
<style scoped lang="stylus">
.font-size-grande
	font-size 28px !important

.texto-menu-interno
	font-size 0.8em

.list-item-height
	min-height 0 !important

.v-list-item
	padding 0 5px !important

.v-list-item__icon
	margin auto 5px !important

.v-list-item--disabled
	cursor not-allowed !important
</style>
